import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { ActiveSubscription } from '../types/plan';

interface GetActiveSubscriptionsResponse {
  success: boolean;
  subscriptions: ActiveSubscription[];
}

class SubscriptionService {
  /**
   * Busca todas as assinaturas ativas do usuário logado
   */
  async getActiveSubscriptions(): Promise<ActiveSubscription[]> {
    try {
      const callable = httpsCallable<void, GetActiveSubscriptionsResponse>(
        functions,
        'getActiveSubscriptions'
      );
      const result = await callable();
      
      if (result.data.success) {
        return result.data.subscriptions;
      }
      
      throw new Error('Falha ao buscar assinaturas');
    } catch (error) {
      console.error('Erro ao buscar assinaturas ativas:', error);
      throw error;
    }
  }

  /**
   * Verifica se o usuário tem uma assinatura ativa de um tipo específico
   */
  hasActiveSubscription(
    subscriptions: ActiveSubscription[],
    sessionLabel?: string
  ): boolean {
    return subscriptions.some(
      sub => !sessionLabel || sub.sessionLabel === sessionLabel
    );
  }

  /**
   * Agrupa assinaturas por tipo de sessão
   */
  groupBySessionType(subscriptions: ActiveSubscription[]): {
    constellation: ActiveSubscription[];
    participation: ActiveSubscription[];
    hours: ActiveSubscription[];
    other: ActiveSubscription[];
  } {
    return {
      constellation: subscriptions.filter(
        sub => sub.sessionLabel === 'Constelação'
      ),
      participation: subscriptions.filter(
        sub => sub.sessionLabel === 'Participação'
      ),
      hours: subscriptions.filter(
        sub => sub.billingType === 'hours'
      ),
      other: subscriptions.filter(
        sub => !sub.sessionLabel && sub.billingType !== 'hours'
      ),
    };
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;
